import { createInteriorRoomCalculator } from "./interior-room-shared.js";

/**
 * Home Office (Phase 13A). No generic windows/doors category (rarely
 * part of a home office conversion on its own) and, notably, no generic
 * electrical allowance either - a home office's electrical scope is
 * priced through its own dedicated `home_office_electrical_data` tier
 * (extra circuits vs. dedicated network/AV wiring) instead, since that's
 * the electrical work that actually differentiates a home office
 * renovation from any other room's.
 */
export const calculateHomeOffice = createInteriorRoomCalculator({
  projectType: "home_office",
  anchorItemId: "home_office_base_renovation",
  tierFeatures: [
    {
      answerKey: "home_office_flooring_type",
      itemIdByTier: { not_changing: null, basic: "home_office_flooring_basic", mid_range: "home_office_flooring_mid", premium: "home_office_flooring_premium" },
      quantityFromSqft: true,
      excludedMessage: "Flooring is not changing - excluded from this estimate."
    },
    {
      answerKey: "home_office_painting",
      itemIdByTier: { not_included: null, walls_only: "home_office_painting_walls", full_room: "home_office_painting_full" },
      quantityFromSqft: true,
      excludedMessage: "Painting was not included - excluded from this estimate."
    },
    {
      answerKey: "home_office_trim",
      itemIdByTier: { keep_existing: null, standard_upgrade: "home_office_trim_standard", premium_millwork: "home_office_trim_premium" },
      excludedMessage: "Trim/millwork is not being upgraded - excluded from this estimate."
    },
    {
      answerKey: "home_office_lighting",
      itemIdByTier: { keep_existing: null, standard_swap: "home_office_lighting_standard", statement_lighting: "home_office_lighting_statement" },
      excludedMessage: "Lighting is not being upgraded - excluded from this estimate."
    },
    {
      answerKey: "home_office_built_ins",
      itemIdByTier: { none: null, standard: "home_office_built_ins_standard", custom: "home_office_built_ins_custom" },
      excludedMessage: "No built-in desk/shelving was requested - excluded from this estimate."
    },
    {
      answerKey: "home_office_electrical_data",
      itemIdByTier: { none: null, extra_circuits: "home_office_electrical_extra_circuits", network_av: "home_office_electrical_network_av" },
      excludedMessage: "No additional electrical/data wiring was requested - excluded from this estimate."
    }
  ],
  demolitionItemId: "home_office_demolition",
  accessibilityItemId: "home_office_accessibility",
  permitDesignItemId: "home_office_permit_design"
});
